var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 46 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0 0.398438)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9164",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "46",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              y: "0.398438",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9164)" } }, [
        _c("path", {
          attrs: {
            d: "M45.9847 0.398438H0V46.3984H45.9847V0.398438Z",
            fill: "#FFC300",
          },
        }),
        _c("path", {
          attrs: {
            d: "M23.3301 0.398438H45.9986V22.9179C33.4795 22.9179 23.3301 12.8352 23.3301 0.398438Z",
            fill: "#F9DF40",
          },
        }),
        _c("path", {
          attrs: {
            d: "M21.8301 22.6797L44.8028 45.5011L21.8301 68.3226V22.6797Z",
            fill: "#F9DF40",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }